__turbopack_context__.v({
  "carouselCard": "styles-module__MpGFRG__carouselCard",
});
